import { useEffect, useState, useCallback } from "react";
import { useConfig } from "../../utensils/ConfigContext";

const useAdminTemplates = () => {
  const { apiToken } = useConfig();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    console.log("🌀 Iniciando carga de plantillas...");
    setLoading(true);
    setError(null);

    try {
      console.log("📡 Haciendo fetch a Baserow (plantillas)...");
      const response = await fetch(
        `https://api.baserow.io/api/database/rows/table/574697/?user_field_names=true`,
        {
          headers: { Authorization: `Token ${apiToken}` },
        }
      );

      console.log("🔄 Respuesta recibida:", response);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Error al obtener plantillas:", errorText);
        throw new Error("Error al obtener plantillas");
      }

      const data = await response.json();
      console.log("✅ Plantillas obtenidas:", data.results);

      setTemplates(data.results);
    } catch (err) {
      console.error("🚨 Error general en fetch:", err.message);
      setError(err.message);
    } finally {
      setLoading(false);
      console.log("✅ Finalizó la carga de plantillas.");
    }
  }, [apiToken]);

  const deleteTemplate = async (id) => {
    console.log("🗑️ Eliminando plantilla con ID:", id);

    try {
      const response = await fetch(
        `https://api.baserow.io/api/database/rows/table/574697/${id}/?user_field_names=true`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Token ${apiToken}`,
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Error al eliminar plantilla: ${response.status} - ${errorText}`
        );
      }

      console.log("✅ Plantilla eliminada con éxito.");
      return true;
    } catch (error) {
      console.error("❌ Error al eliminar plantilla:", error.message);
      throw error;
    }
  };

  return { templates, loading, error, refetch, deleteTemplate };
};

// ✅ Función externa para obtener una plantilla por ID
export const getTemplateById = async (templateId, token) => {
  console.log("🔍 Buscando plantilla por ID:", templateId);

  try {
    const response = await fetch(
      `https://api.baserow.io/api/database/rows/table/574697/${templateId}/?user_field_names=true`,
      {
        headers: { Authorization: `Token ${token}` },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error al obtener plantilla: ${response.status} - ${errorText}`
      );
    }

    const data = await response.json();
    console.log("📦 Plantilla obtenida:", data);
    return data;
  } catch (error) {
    console.error("❌ getTemplateById error:", error.message);
    throw error;
  }
};

export default useAdminTemplates;
